import vocab from '../../../config/channels';
import { TSite } from '../../../contexts/site/site-context';

// With one site and one channel there's nothing to choose, so it's on to the menu (or, where the
// channel needs a postcode or a venue first, the choice stays)
export const singleSiteRedirect = (sites: TSite[]) => {
    if (sites.length !== 1) {
        return null;
    }

    const site = sites[0];
    const channels = Object.keys(site.channels);

    if (channels.length !== 1) {
        return null;
    }

    if (channels[0] === 'dine_in') {
        return `/${vocab.dineIn.handle}/${site.handle}/table`;
    }

    if (['delivery', 'catering', 'venues'].includes(channels[0])) {
        return null;
    }

    return `/${channels[0]}/${site.handle}`;
};
